"use strict";
exports.__esModule = true;
var gtag = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (typeof window !== "undefined") {
        if (typeof (window === null || window === void 0 ? void 0 : window.gtag) === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        window.gtag.apply(window, args);
    }
};
exports["default"] = gtag;
